<template>
    <div>
        <div class="tab-content">
            <div class="tab-pane active" id="core_gateways">
                <bank-gateways/>
            </div>

        </div>
    </div>
</template>

<script>
import bankGateways from './bank-gateways'
export default {
    components: {
        bankGateways,
    },
}
</script>

<style>

</style>